import { formatUsd } from "../../config/trading";

export function EarningsSummaryCards({ summary }) {
  const positive = summary.change_amount >= 0;

  return (
    <div className="earnings-summary-grid">
      <div className="metric compact" data-testid="earnings-current-value">
        <span className="label">Current</span>
        <strong className="mono metric-value">{formatUsd(summary.current_earnings)}</strong>
      </div>
      <div className="metric compact" data-testid="earnings-previous-value">
        <span className="label">Previous</span>
        <strong className="mono metric-value">{formatUsd(summary.previous_earnings)}</strong>
      </div>
      <div className="metric compact" data-testid="earnings-change-value">
        <span className="label">Change</span>
        <strong className={`mono metric-value ${positive ? "positive" : "negative"}`}>
          {formatUsd(summary.change_amount)} ({summary.change_pct}%)
        </strong>
      </div>
    </div>
  );
}